import { DeviceDetectorService } from "ngx-device-detector";
import { EditDiscoverModalComponent } from "./../edit-discover-modal/edit-discover-modal.component";
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  TemplateRef,
} from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { TranslateService } from "@ngx-translate/core";
import { Discover } from "src/models/discover";
import { PictureService } from "src/services/picture.service";
import { DiscoverService } from "src/services/discover.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Picture } from "src/app/tools/Gallery/models/picture.model";
import { AuthService } from "src/services/guard/auth.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ConfirmationService } from "primeng/api";

@Component({
  selector: "app-discover-place",
  templateUrl: "./discover-place.component.html",
  styleUrls: ["./discover-place.component.scss"],
})
export class DiscoverPlaceComponent extends BaseComponent implements OnInit {
  discover: Discover;
  modalRef: BsModalRef;

  currentLang: string;
  isAdmin: boolean;

  galleryLoading: boolean;
  currentGallery: Picture[];
  isPreview: boolean;
  hasPicture: boolean;

  constructor(
    translate: TranslateService,
    private pictureService: PictureService,
    private cd: ChangeDetectorRef,
    private sanatizer: DomSanitizer,
    private discoverService: DiscoverService,
    private route: ActivatedRoute,
    private router: Router,
    authService: AuthService,
    private bsModalService: BsModalService,
    private confirm: ConfirmationService,
    deviceDetectorService: DeviceDetectorService
  ) {
    super(translate, authService, deviceDetectorService, route);
    this.pictureService._picturesCast.subscribe((pics) => {
      this.currentGallery = pics.map(
        (x) =>
          new Picture({
            id: x.id,
            name: x.displayName,
            description: x.description,
            src: x.path,
          })
      );
    });

    this.pictureService.previewCast.subscribe((p) => {
      this.isPreview = p;
    });

    this.langChange.subscribe((lg) => this.ngOnInit());
  }

  ngOnInit(): void {
    this.discoverService
      .getDiscoverById(this.route.snapshot.params.id)
      .subscribe((discover) => {
        this.discover = discover;
        this.translate.currentLang = this.translate.currentLang;
        this.discover.safeUrl = this.getSafeUrl(this.discover, "umapUrl");
        this.cd.markForCheck();
        this.pictureService
          .getPicturesForDiscover(this.discover.id)
          .subscribe(() => {
            this.hasPicture = this.pictureService.getNumberOfPictures() > 0;
          });
      });
  }

  getSafeUrl(discover: Discover, property: string) {
    const url = this.getDiscoverProperty(discover, property);
    return this.sanatizer.bypassSecurityTrustResourceUrl(url);
  }

  getDiscoverProperty(discover: Discover, property: string) {
    const lang =
      this.translate.currentLang.charAt(0).toUpperCase() +
      this.translate.currentLang.slice(1);
    return discover[property + lang];
  }

  getDiscoverTitle(discover: Discover) {
    const title = this.getDiscoverProperty(discover, "title");
    return title.replace(/^[^\d]*(\d+)/, "");
  }

  navigateBack() {
    this.router.navigate(["discover"]);
  }

  showPreview(picture: Picture) {
    this.pictureService.getCurrentPicture(picture.id);
    this.pictureService.preview();
  }

  discoverModal() {
    const discoverModel = Object.assign({}, this.discover);
    this.modalRef = this.bsModalService.show(EditDiscoverModalComponent, {
      class: "xlarge",
      initialState: { discoverModel: discoverModel },
    });
  }

  deleteDiscover() {
    this.confirm.confirm({
      message: "Are you Sure?",
      accept: () => {
        this.discoverService.deleteDiscover(this.discover).subscribe(() => {
          this.router.navigate["discovers"];
        });
      },
    });
  }

  getDiscoverGpxUrl(discover: Discover): string {
    return this.getDiscoverTitle(discover) + ".gpx";
  }
}
